import React from "react";
import { useLocation } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import ServicesDetailsMetaData from "../Data/ServicesDetailsMetaData";
import "../Components/css/Srvsales.css";
import OurKeyCapabilities from "../Components/OurKeyCapabilities";
import ImpactSection from "../Components/ImpactSection";
import { servicesData } from "../Components/serviceMetaData";
import "../Components/css/serviceBanerFile.css";
import ServicedDetailBanner from "../Components/ServicedDetailBanner.js";
import NotFound from "./NotFound";
import Navbar2 from "../Components/Navbar2.js";
import VoicesLegacyServiceSections from "../voices/VoicesLegacyServiceSections";
export default function Sales() {
  const location = useLocation();
  let servicePath;
  try {
    servicePath = decodeURI(location.pathname);
  } catch {
    servicePath = "";
  }
  const slug = servicePath.toLowerCase().replace(/\/+$/, "").split("/services/")[1] || "";

  const toSlug = (str) =>
    str
      ?.toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  const currentService = servicesData.find(
    (service) => toSlug(service.name) === slug
  );

  const serviceLogo = ServicesDetailsMetaData.find(
    (item) => item.path === slug
  )?.img || null;

  if (!currentService) {
    return <NotFound />;
  }

  return (
    <div>
      <Navbar2 />
      <ServicedDetailBanner
        serviveLogo={currentService.logo || serviceLogo}
        serviceName={currentService.name}
        serviceTitle={currentService.headline || null}
        serviceImage={currentService.image || null}
        servicePdfUrl={currentService.pdf_Url || null}
      />

      <OurKeyCapabilities capabilities={currentService.capabilities} />

      <ImpactSection impact={currentService.impact} />

      <VoicesLegacyServiceSections service={currentService} />

      <ScrollToTop />
    </div>
  );
}
